import { useCallback } from 'react';
import { useMap } from 'react-use';

export default function useEntityMap<T>(initialValue?: Record<string, T>) {
  const [selectedItemsMap, { set, remove, get }] = useMap(initialValue);

  const toggle = useCallback(
    (key: string, item: T) => {
      if (get(key)) {
        remove(key);
      } else {
        set(key, item);
      }
    },
    [get, remove, set],
  );

  return {
    selectedItemsMap,
    toggle,
    remove,
    set,
    get,
  };
}
